





import { Component, Vue, Prop } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'

@Component({
  components: {
    Button
  }
})
export default class AddOrRemove extends Vue {
  @Prop()
  showAdd!: boolean
}
